import { useContext } from 'react';

import { DeleteTagContext } from './delete-tag-context';

export const useOpenDeleteTagDialog = () => {
  const { openDeleteTag } = useContext(DeleteTagContext);
  return openDeleteTag;
};
